"use strict";

exports.__esModule = true;
var MOVE_NONE = exports.MOVE_NONE = 0;

var MOVE_LEFT = exports.MOVE_LEFT = 1;
var MOVE_RIGHT = exports.MOVE_RIGHT = 2;
var MOVE_HORIZONTAL = exports.MOVE_HORIZONTAL = MOVE_LEFT | MOVE_RIGHT;

var MOVE_TOP = exports.MOVE_TOP = 4;
var MOVE_BOTTOM = exports.MOVE_BOTTOM = 8;

var MOVE_CENTER = exports.MOVE_CENTER = 16;

var MOVE_VERTICAL = exports.MOVE_VERTICAL = MOVE_TOP | MOVE_BOTTOM;

var MOVE_ALL = exports.MOVE_ALL = MOVE_HORIZONTAL | MOVE_VERTICAL;